<template>
  <div>
    <BrandComponentSearch></BrandComponentSearch>

    <v-data-table dense
                  :headers="getColumns"
                  :items="getComponentList"
                  item-key="id"
                  class="elevation-1"
                  :options.sync="options"
                  :server-items-length="totalRecords"
                  :loading="loading"
                  :footer-props="{
          'items-per-page-options': [20, 50, 100]
        }"
                  @update:options="updateOptions"
                  :height="windowHeight"
    >
      <template v-slot:item.mpn="{ item }">
        <span>
            <router-link :to="{name:'BrandComponentItem', params: { brandComponentId: item.id}}">
              {{ item.mpn }}
            </router-link>
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {createHelpers} from 'vuex-map-fields'
// import 'vue-good-table/dist/vue-good-table.css';

import BrandComponentItem from '@/components/Brand/BrandComponentItem'
import BrandComponentSearch from "@/components/Brand/BrandComponentSearch";

const { mapFields } = createHelpers({
  getterType: 'getBrandComponentListField',
  mutationType: 'updateBrandComponentListField',
});

export default {
  name: 'BrandComponentList',

  components: {
    BrandComponentItem,
    BrandComponentSearch
  },

  computed: {
    ...mapGetters(['getComponentList', 'getColumns']),
    ...mapFields(['options', 'options.rowsPerPageItems', 'options.sortBy', 'totalRecords', 'loading']),
    getShortTable() {
      return this.shortTable
    }
  },

  methods: {
    ...mapActions(['fetchComponentList', 'fetchCategoryList', 'fetchSubCategoryList',
      'fetchBrandComponentCategoryParameters']),
    updateOptions(params) {
      console.log('updateOptions')
      console.log(params)
      this.fetchComponentList();
    },
    onShortChange(params) {
      this.changeWidthTables(params)
    },
    onResize() {
      this.windowHeight = (window.innerHeight - 180) + "px"
      this.windowWidth = (window.innerWidth - 180) + "px"
      console.log('windowHeight')
      console.log(this.windowHeight)
    },
  },

  async mounted() {
    await this.fetchCategoryList();
    window.addEventListener("resize", this.onResize)
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  data() {
    return {
      shortTable: true,
      windowHeight: (window.innerHeight - 180) + 'px',
      windowWidth: window.innerWidth + "px",
    }
  }
}
</script>

<style scoped lang="scss">
.v-input--switch {
  margin-top: 0px;
  padding: 5px;
}

//* {
//  z-index: 1;
//}
</style>
